/**
 * API Configuration
 * Centralized configuration for Payload CMS API endpoints
 * Uses environment variables for different deployment environments
 */

// Get API base URL from environment variable with fallback to localhost
const API_BASE_URL = import.meta.env.VITE_PAYLOAD_API_URL || 'http://localhost:3001/api'

/**
 * API endpoints configuration
 */
export const API_ENDPOINTS = {
  activities: `${API_BASE_URL}/activities`,
  packages: `${API_BASE_URL}/packages`,
  destinations: `${API_BASE_URL}/destinations`,
  formSubmissions: `${API_BASE_URL}/form-submissions`,
  blogPosts: `${API_BASE_URL}/blog-posts`,
  pages: `${API_BASE_URL}/pages`,
  media: `${API_BASE_URL}/media`,
  testimonials: `${API_BASE_URL}/testimonials`,
  siteSettings: `${API_BASE_URL}/globals/site-settings`,
}

/**
 * Fetch data from API with error handling
 * @param {string} endpoint - The API endpoint to fetch from
 * @param {object} options - Fetch options (method, headers, body, etc.)
 * @returns {Promise<object>} - The API response data
 */
export const fetchFromAPI = async (endpoint, options = {}) => {
  try {
    const response = await fetch(endpoint, {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    })

    if (!response.ok) {
      throw new Error(`API request failed: ${response.status} ${response.statusText}`)
    }

    return await response.json()
  } catch (error) {
    console.error('API Error:', error)
    throw error
  }
}

/**
 * Helper to build query strings for Payload API
 * @param {object} params - Query parameters
 * @returns {string} - Query string
 */
export const buildQueryString = (params = {}) => {
  const query = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      query.append(key, value)
    }
  })

  return query.toString() ? `?${query.toString()}` : ''
}

export default API_ENDPOINTS
